import { Link } from 'react-router-dom'
import capitalize from 'lodash/capitalize'
import { Review } from '@fable/types'
import { css, useTheme } from '@fable/theme'
import { FlexBox, Emoji, ReviewStars, Text } from '@fable/components'
import { ReviewAttribute } from 'types'

import { clubRoute } from 'app/clubs/routes'

export const BookDetailReviewContent: React.VFC<{ review: Review }> = ({
  review,
}) => {
  const { colors } = useTheme()

  return (
    <div
      className={css`
        margin-top: 8px;
        padding: 16px;
        background-color: ${colors.almostWhite};
        border-radius: 12px;
        position: relative;
      `}
    >
      <ReviewStars
        readOnly
        color={colors.sapphireBlue}
        rating={review?.rating || 0}
      />
      {review?.emoji_reaction && (
        <Emoji
          className={css`
            position: absolute;
            top: -16px;
            right: 16px;
          `}
          emoji={review?.emoji_reaction}
          size={46}
        />
      )}
      {review?.review ? (
        <Text
          className={css`
            margin-top: 16px;
            display: block;
          `}
          type="body"
          sizing="M"
        >
          &ldquo;{review.review}&rdquo;
        </Text>
      ) : null}
      {review?.club ? (
        <div
          className={css`
            margin-top: 16px;
            padding: 4px 8px;
            border-radius: 100px;
            background-color: ${colors.whiteFang};
            display: table;
          `}
        >
          <Text
            className={css`
              margin-right: 4px;
              display: inline-block;
              vertical-align: middle;
            `}
            type="label"
            sizing="L"
            color={colors.greyNeutral}
          >
            Reviewed in:
          </Text>
          <Link to={clubRoute({ club: review?.club })}>
            <Text
              className={css`
                display: inline-block;
                vertical-align: middle;
                letter-spacing: -0.2px;
                cursor: pointer;
              `}
              type="link"
              sizing="M"
              color={colors.denim}
            >
              {review?.club.title}
            </Text>
          </Link>
        </div>
      ) : null}
      {review?.attributes?.length ? (
        <FlexBox
          className={css`
            margin-top: 8px;
          `}
          flexWrap="wrap"
        >
          {review.attributes.map((attribute: ReviewAttribute, i: number) => (
            <Text
              key={i}
              className={css`
                margin-right: 4px;
                margin-top: 8px;
                padding: 4px 8px;
                border-radius: 100px;
                background-color: ${colors.sapphireBlue};
                letter-spacing: -0.2px;
              `}
              type="link"
              sizing="M"
              color={colors.whiteFang}
            >
              {capitalize(attribute.name)}
            </Text>
          ))}
        </FlexBox>
      ) : null}
    </div>
  )
}
